<template>
    <div class="newFill">
        <NewTopFixed
            logo
            :active="0"
            :headerProvince="province"
            :is_login="is_login"
            @closeHeadersf="closeHeadersf"
            @getHomePage="getHomePage"
        ></NewTopFixed>
        <BannerView :headerProvince="province" @homePageAd="homePageAd"></BannerView>
        <div class="main">
            <div class="mainBox fr-ac-jsb" style="height: 70px">
                <div class="flex-1 firstLeft fr-ac-jc" @click="homeSearch">
                    <div class="mainSearch mr-20 fr-ac pl-20">
                        <p>请输入关键字搜索</p>
                    </div>
                    <div class="mainButton fr-ac-jc">搜索</div>
                </div>
                <div
                    class="ml-15 fr-ac-jc bold firstRight"
                    v-for="(item, ind) in commonListCopy"
                    :key="ind"
                    @click="toCommon(item)"
                >
                    开通{{ item.title }}系统
                </div>
            </div>
            <div class="mainBox grid-3" v-if="T_A.length!==0">
                <a
                    :href="item.link"
                    v-for="(item, ind) in T_A"
                    :key="ind"
                    target="_blank"
                >
                    <el-image
                        :src="item.img"
                        @click="getAdsClick(item.ads_id)"
                        class="WH-100"
                    ></el-image>
                </a>
            </div>
            <div class="mainBox grid-7 bg-white">
                <div
                    v-for="item in commonList"
                    :key="item.id"
                    class="fr-ac-jc pt-15 pb-15"
                    @click="toCommon(item)"
                >
                    <el-image
                        :src="'https://file.gkzzd.cn' + item.img"
                        style="width: 15px; height: 15px"
                    ></el-image>
                    <div class="ml-5">{{ item.title }}</div>
                </div>
            </div>
            <div class="mainBox grid-3">
                <div class="bg-white pb-5">
                    <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                        <span class="one bold">招考公告</span>
                        <span @click="toNews('招考公告')" class="fs-12"
                            >查看更多></span
                        >
                    </p>
                    <el-popover
                        ref="popover"
                        placement="top"
                        v-for="item in list1"
                        :key="item.id"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="
                            calculateLength(item.title) >
                            (1200 / 3 - 6 - 30) * 0.75
                                ? false
                                : true
                        "
                    >
                        <div class="popover_div" slot="reference">
                            <a
                                slot="reference"
                                class="fr-jsb list2Item py-2 px-15 fs-13"
                                :href="`/school/article?id=${item.id}`"
                                target="_blank"
                            >
                                <img
                                    :src="list_url"
                                    alt=""
                                    width="12px"
                                    height="14px"
                                />
                                <span
                                    class="bold ellipsis"
                                    style="width: 75%"
                                    >{{ item.title }}</span
                                >
                                <span class="color-99">{{
                                    item.publishtime
                                }}</span>
                            </a>
                        </div>
                    </el-popover>
                </div>
                <div class="bg-white pb-5">
                    <div class="fr-ac-jsb">
                        <div class="fr">
                            <div
                                v-for="item in tab_list"
                                :key="item.id"
                                :class="
                                    tab_index == item.id
                                        ? 'tab_active'
                                        : 'tab_list'
                                "
                                @click="tab_click(item)"
                            >
                                {{ item.title }}
                            </div>
                        </div>
                        <span
                            @click="
                                toNews(tab_index == 1 ? '头条新闻' : '院校动态')
                            "
                            class="fs-12"
                            style="color: #3c78ff; padding-right: 29px"
                            >查看更多></span
                        >
                    </div>
                    <a
                        style="width: 100%"
                        class="red ellipsis bold py-2 px-20"
                        :href="`/school/article?id=${top_list.id}`"
                        target="_blank"
                    >
                        {{ top_list.title }}
                    </a>
                    <el-popover
                        ref="popover"
                        placement="top"
                        v-for="item in list3"
                        :key="item.id"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="
                            calculateLength(item.title) >
                            (1200 / 3 - 6 - 30) * 0.75
                                ? false
                                : true
                        "
                    >
                        <div class="popover_div" slot="reference">
                            <a
                                slot="reference"
                                class="fr-jsb list2Item py-2 px-15 fs-13"
                                :href="`/school/article?id=${item.id}`"
                                target="_blank"
                            >
                                <img
                                    :src="list_url"
                                    alt=""
                                    width="12px"
                                    height="14px"
                                />
                                <span
                                    class="bold ellipsis"
                                    style="width: 75%"
                                    >{{ item.title }}</span
                                >
                                <span class="color-99">{{
                                    item.publishtime
                                }}</span>
                            </a>
                        </div>
                    </el-popover>
                </div>
                <div class="bg-white pb-5">
                    <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                        <span class="one bold">热门专题</span
                        ><span @click="toNews('热门专题')" class="fs-12"
                            >查看更多></span
                        >
                    </p>
                    <el-popover
                        ref="popover"
                        placement="top"
                        v-for="(item, ind) in list2"
                        :key="ind"
                        width="200"
                        trigger="hover"
                        :content="item.title"
                        :disabled="
                            calculateLength(item.title) >
                            (1200 / 3 - 6 - 30) * 0.75
                                ? false
                                : true
                        "
                    >
                        <div class="popover_div" slot="reference">
                            <a
                                slot="reference"
                                class="fr-jsb list2Item py-2 px-15 fs-13"
                                :href="`/school/special_subject?id=${item.id}`"
                                target="_blank"
                            >
                                <img
                                    :src="list_url"
                                    alt=""
                                    width="12px"
                                    height="14px"
                                />
                                <span
                                    class="bold ellipsis"
                                    style="width: 75%"
                                    >{{ item.title }}</span
                                >
                                <span class="color-99">{{
                                    item.publishtime
                                }}</span>
                            </a>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="mainBox grid-4" v-if="AList.length !== 0">
                <a
                    :href="item.link"
                    v-for="(item, ind) in AList"
                    :key="ind"
                    target="_blank"
                >
                    <el-image
                        :src="item.img"
                        class="WH-100"
                        @click="getAdsClick(item.ads_id)"
                    ></el-image>
                </a>
            </div>
            <div class="mainBox fr fs-20 bold bg-white" v-if="text_link.length!==0">
                <a
                    :href="item.link"
                    v-for="(item, ind) in text_link"
                    :key="ind"
                    class="flex-1 fr-ac-jc mb-18 mt-18 borderR"
                    target="_blank"
                    @click="getAdsClick(item.ads_id)"
                    >{{ item.text }}</a
                >
            </div>
            <div class="mainBox bg-white">
                <p class="fs-20 thirdTitle fr-ac-jsb pt-15 pb-15">
                    <span class="one bold">院校直通车</span
                    ><span class="fs-16" @click="toSchool">查看更多></span>
                </p>
                <!-- <div
                    style="padding: 20px 28px 4px 29px"
                    class="fr-ac-jsb fwrap"
                >
                    <div
                        v-for="(item, ind) in schoolList"
                        :key="ind"
                        class="schoolItem mb-20 fr-ac"
                        @click="toSchoolDetail(item)"
                    >
                        <img
                            :src="item.img"
                            alt=""
                            width="57px"
                            height="57px"
                            class="ml-30 mr-20"
                        />
                        <div>
                            <p class="font-400 fs-20">{{ item.school }}</p>
                            <p class="color-99 fs-14 mt-5">{{ item.str }}</p>
                        </div>
                    </div>
                </div> -->
                <div style="padding: 20px 28px 4px 29px">
                    <div class="newBus">
                        <p
                            v-for="item in schoolList"
                            :key="item.province"
                            class="newbus_title"
                            :class="
                                newbus == item.province ? 'newbus_active' : ''
                            "
                            @mouseover="newbusMove(item)"
                        >
                            {{ item.province }}
                        </p>
                    </div>
                    <div class="newbuslist">
                        <p
                            v-for="item in newbuslist"
                            :key="item.school_id"
                            :class="item.is_red == 1 ? 'red' : ''"
                        >
                            <a @click="toSchoolDetail(item)" class="newbusA">{{
                                item.name
                            }}</a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="mainBox grid-4" v-if="BList.length !== 0">
                <a
                    :href="item.link"
                    v-for="(item, ind) in BList"
                    :key="ind"
                    target="_blank"
                >
                    <el-image
                        :src="item.img"
                        class="WH-100"
                        @click="getAdsClick(item.ads_id)"
                    ></el-image>
                </a>
            </div>
            <div class="mainBox fr-jsb">
                <div class="grid-2" style="width: 85%">
                    <div class="bg-white pb-10">
                        <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                            <span class="one bold">院校介绍</span>
                            <span @click="toNews('院校介绍')" class="fs-12"
                                >查看更多></span
                            >
                        </p>
                        <el-popover
                            ref="popover"
                            placement="top"
                            v-for="item in list4"
                            :key="item.id"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="
                                calculateLength(item.title) >
                                ((1200 * 0.85) / 2 - 5 - 40) * 0.8
                                    ? false
                                    : true
                            "
                        >
                            <div class="popover_div" slot="reference">
                                <a
                                    slot="reference"
                                    class="fr-jsb list2Item py-2 px-20 fs-13"
                                    :href="`/school/article?id=${item.id}`"
                                    target="_blank"
                                >
                                    <img
                                        :src="list_url"
                                        alt=""
                                        width="12px"
                                        height="14px"
                                    />
                                    <span
                                        class="bold ellipsis"
                                        style="width: 80%"
                                        >{{ item.title }}</span
                                    >
                                    <span class="color-99">{{
                                        item.publishtime
                                    }}</span>
                                </a>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-10">
                        <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                            <span class="one bold">历年分数</span>
                            <span @click="toNews('历年分数')" class="fs-12"
                                >查看更多></span
                            >
                        </p>
                        <el-popover
                            ref="popover"
                            placement="top"
                            v-for="item in list5"
                            :key="item.id"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="
                                calculateLength(item.title) >
                                ((1200 * 0.85) / 2 - 5 - 40) * 0.8
                                    ? false
                                    : true
                            "
                        >
                            <div class="popover_div" slot="reference">
                                <a
                                    slot="reference"
                                    class="fr-jsb list2Item py-2 px-20 fs-13"
                                    :href="`/school/article?id=${item.id}`"
                                    target="_blank"
                                >
                                    <img
                                        :src="list_url"
                                        alt=""
                                        width="12px"
                                        height="14px"
                                    />
                                    <span
                                        class="bold ellipsis"
                                        style="width: 80%"
                                        >{{ item.title }}</span
                                    >
                                    <span class="color-99">{{
                                        item.publishtime
                                    }}</span>
                                </a>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-10">
                        <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                            <span class="one bold">招生计划</span>
                            <span @click="toNews('招生计划')" class="fs-12"
                                >查看更多></span
                            >
                        </p>
                        <el-popover
                            ref="popover"
                            placement="top"
                            v-for="item in list6"
                            :key="item.id"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="
                                calculateLength(item.title) >
                                ((1200 * 0.85) / 2 - 5 - 40) * 0.8
                                    ? false
                                    : true
                            "
                        >
                            <div class="popover_div" slot="reference">
                                <a
                                    slot="reference"
                                    class="fr-jsb list2Item py-2 px-20 fs-13"
                                    :href="`/school/article?id=${item.id}`"
                                    target="_blank"
                                >
                                    <img
                                        :src="list_url"
                                        alt=""
                                        width="12px"
                                        height="14px"
                                    />
                                    <span
                                        class="bold ellipsis"
                                        style="width: 80%"
                                        >{{ item.title }}</span
                                    >
                                    <span class="color-99">{{
                                        item.publishtime
                                    }}</span>
                                </a>
                            </div>
                        </el-popover>
                    </div>
                    <div class="bg-white pb-10">
                        <p class="fs-16 thirdTitle fr-ac-jsb py-10 mb-5">
                            <span class="one bold">招生章程</span>
                            <span @click="toNews('招生章程')" class="fs-12"
                                >查看更多></span
                            >
                        </p>
                        <el-popover
                            ref="popover"
                            placement="top"
                            v-for="item in list7"
                            :key="item.id"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="
                                calculateLength(item.title) >
                                ((1200 * 0.85) / 2 - 5 - 40) * 0.8
                                    ? false
                                    : true
                            "
                        >
                            <div class="popover_div" slot="reference">
                                <a
                                    slot="reference"
                                    class="fr-jsb list2Item py-2 px-20 fs-13"
                                    :href="`/school/article?id=${item.id}`"
                                    target="_blank"
                                >
                                    <img
                                        :src="list_url"
                                        alt=""
                                        width="12px"
                                        height="14px"
                                    />
                                    <span
                                        class="bold ellipsis"
                                        style="width: 80%"
                                        >{{ item.title }}</span
                                    >
                                    <span class="color-99">{{
                                        item.publishtime
                                    }}</span>
                                </a>
                            </div>
                        </el-popover>
                    </div>
                </div>
                <div class="bg-white" style="width: 14%; padding: 0 35px">
                    <div
                        v-for="item in commonList"
                        :key="item.id"
                        class="fr-ac pt-20"
                        @click="toCommon(item)"
                    >
                        <el-image
                            :src="'https://file.gkzzd.cn' + item.img"
                        ></el-image>
                        <div class="ml-5">{{ item.title }}</div>
                    </div>
                </div>
            </div>
            <div class="mainBox mb-20 bg-white">
                <p class="fs-20 thirdTitle fr-ac-jsb pt-15 pb-15">
                    <span class="one bold">查试卷</span
                    ><span class="fs-16" @click="toPaper">查看更多></span>
                </p>
                <div style="padding: 20px">
                    <div class="fr mb-20">
                        <p
                            v-for="(item, ind) in testTitleList"
                            :key="ind"
                            class="testPaperItem fr-ac-jc"
                            :class="
                                testPaperActive == ind
                                    ? 'testPaperItemActive'
                                    : ''
                            "
                            @click="testPaperClick(ind)"
                        >
                            {{ item.title }}
                        </p>
                    </div>
                    <div class="grid-2">
                        <!-- <div
                            v-for="(child, indnx) in testPaperList"
                            :key="indnx"
                            @click="toPaperDetai(child)"
                            class="testChildItem fs-16"
                        >
                            <p
                                class="ellipsis bold mb-15"
                                style="width: calc(100% - 100px)"
                            >
                                {{ child.title }}
                            </p>
                            <div class="fr-ac-jsb color-99">
                                <p>{{ child.publishtime }}</p>
                                <p>
                                    <span>阅读量：{{ child.views }}</span
                                    ><span class="ml-19"
                                        >下载量：{{ child.downloads }}</span
                                    >
                                </p>
                            </div>
                        </div> -->

                        <el-popover
                            ref="popover"
                            placement="top"
                            v-for="item in testPaperList"
                            :key="item.id"
                            width="200"
                            trigger="hover"
                            :content="item.title"
                            :disabled="
                                calculateLength(item.title) >
                                ((1200 - 40) / 2 - 5 - 40) * 0.75
                                    ? false
                                    : true
                            "
                        >
                            <div class="popover_div" slot="reference">
                                <a
                                    slot="reference"
                                    class="fr-jsb pl-15 pr-15 fs-13"
                                    :href="`/school/article?id=${item.id}`"
                                    target="_blank"
                                >
                                    <span
                                        class="bold ellipsis"
                                        style="width: 75%"
                                        >{{ item.title }}</span
                                    >
                                    <span class="color-99">{{
                                        item.publishtime
                                    }}</span>
                                </a>
                            </div>
                        </el-popover>
                    </div>
                </div>
            </div>
            <a :href="coupletLeft.link" target="_blank" v-if="coupletLeft.img">
                <el-image :src="coupletLeft.img" class="leftImg" @click="getAdsClick(coupletLeft.ads_id)"></el-image>
            </a>
            <a :href="coupletRight.link" target="_blank" v-if="coupletRight.img">
                <el-image :src="coupletRight.img" class="rightImg" @click="getAdsClick(coupletRight.ads_id)"></el-image>
            </a>
        </div>
        <FooterView></FooterView>

        <div class="suspension py-20 px-5">
            <el-popover
                placement="left"
                v-for="item in hang_list"
                :key="item.id"
                trigger="hover"
            >
                <div class="fc-ac-jc">
                    <img :src="`https://file.gkzzd.cn${item.QR_code}`" alt="" style="width: 150px;height: 150px;"/>
                    <div class="mt-5">{{ item.content }}</div>
                </div>
                <div slot="reference" class="fc-ac-jc py-10">
                    <img
                        :src="`https://file.gkzzd.cn${item.icon}`"
                        alt=""
                        style="width: 25px; height: 25px"
                    />
                    <div class="fs-14 mt-5">{{ item.title }}</div>
                </div>
            </el-popover>
        </div>

        <div class="province_pop_up fr-ac-jc" v-if="selectProvince">
            <ProvinceView
                :provincelist="provincelist"
                @closeProvince="closeProvince"
            ></ProvinceView>
        </div>

        <div class="province_pop_up fr-ac-jc" v-if="dialogList.isTrue">
            <DialogView :dialogList="dialogList" @remove="remove" />
        </div>
    </div>
</template>
<script>
import ProvinceView from "@/components/provinceView.vue";
import FooterView from "@/components/footerView.vue";
import BannerView from "@/components/bannerView.vue";
import store from "@/store";
import { getCookie, setCookie } from "@/utils/common";
export default {
    components: {
        ProvinceView,
        FooterView,
        BannerView
    },
    data() {
        return {
            province: "",
            province_id: getCookie("province_id"),
            provincelist: {
                width: "800px",
            },
            selectProvince: getCookie("province") ? false : true,
            commonList: [
                {
                    id: 1,
                    title: "查大学",
                    img: "/www/gkzzd/uploads/20250114/7b1ae133d8e0a4af4fc736a9790bbf7c.png",
                    path: "/fill/fill_school",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 2,
                    title: "查专业",
                    img: "/www/gkzzd/uploads/20250114/73d440bef01831182e8b5d637e3f4db9.png",
                    path: "/fill/fill_speciality",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 5,
                    title: "查试卷",
                    img: "/www/gkzzd/uploads/20250114/a1e9e9331fb690d0ae1f79fb0965540a.png",
                    path: "/fill/fill_paper",
                    is_open: false,
                    is_vip: false,
                    business: "五查系统",
                },
                {
                    id: 3,
                    title: "选科系统",
                    img: "/www/gkzzd/uploads/20250114/7037bad37f18e2837a2fe7dcaff35527.png",
                    path: "/fill/fill_optional",
                    is_open: false,
                    is_vip: true,
                    business: "选科系统",
                },
                {
                    id: 4,
                    title: "模拟填报",
                    img: "/www/gkzzd/uploads/20250114/ba6ea7435f8dc8618f65cd38fbe8ca05.png",
                    path: "/fill/fill_index",
                    is_open: false,
                    is_vip: false,
                    business: "模拟填报",
                },
                {
                    id: 6,
                    title: "测一测",
                    img: "/www/gkzzd/uploads/20250114/8d6db3dc8ebba842741e93ce99e9ea5c.png",
                    path: "",
                    is_open: false,
                    is_vip: false,
                    business: "测一测",
                },
                {
                    id: 7,
                    title: "查录取",
                    img: "/www/gkzzd/uploads/20250114/19d0138e6c21489b9e06cad8a09f9d8f.png",
                    path: "",
                    is_open: true,
                    is_vip: true,
                    business: "查录取",
                },
            ],
            commonListCopy: [],
            newsList: [],
            generalList: [],
            schoolList: [],
            testTitleList: [
                {
                    title: "最新",
                },
                {
                    title: "语文",
                },
                {
                    title: "数学",
                },
                {
                    title: "英语",
                },
                {
                    title: "物理",
                },
                {
                    title: "化学",
                },
                {
                    title: "生物",
                },
                {
                    title: "政治",
                },
                {
                    title: "地理",
                },
                {
                    title: "历史",
                },
                // {
                //     title: "文数",
                // },
                // {
                //     title: "理数",
                // },
                // {
                //     title: "文综",
                // },
                // {
                //     title: "理综",
                // },
                {
                    title: "日语",
                },
                {
                    title: "其他",
                },
            ],
            testPaperList: [],
            testPaperActive: 0,
            paper_subject: "最新",
            banner: {
                link: "",
                img: "",
                ads_id: "",
            },
            coupletLeft: { link: "", img: "", ads_id: "" },
            coupletRight: { link: "", img: "", ads_id: "" },
            T_A: [],
            AList: [],
            BList: [],
            text_link: [],
            date: new Date().getFullYear(),
            dialogList: {
                type: "C",
                isTrue: false,
                province: "",
                title: "",
                //按钮名称
                button: "开通",
                //按钮
                save: true,
                remove: false,
                cancel: false,
                //禁用
                disabled: false,
                disabledEdit: false,
                //用户信息
                crowd: "",
                candidates_identity: "",
                graduation: "",
                school_city: "",
                school_province: "",
                school_type: "",
                middle_school: "",
                width: "30%",
                showClose: false,
            },
            is_login: false,
            newbus: "闽",
            newbuslist: [],
            tab_list: [
                {
                    id: 1,
                    title: "头条新闻",
                },
                {
                    id: 2,
                    title: "院校动态",
                },
            ],
            tab_index: 1,
            list1: [],
            list2: [],
            list3: [],
            list4: [],
            list5: [],
            list6: [],
            list7: [],
            top_list: {},
            list_url:
                "https://file.gkzzd.cn/www/gkzzd/uploads/20241023/6e44054dfbdf1ad852b7cf061de2076c.png",
            hang_list: [
                {
                    id: 1,
                    title: "小程序",
                    content: "微信扫码访问小程序",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/f9d70655daf7b5843d967b9c2c7f1d9b.png",
                    icon: "/www/gkzzd/uploads/20250321/941fe8c7d744c52c3bb84534b6612a04.png",
                },
                {
                    id: 2,
                    title: "APP",
                    content: "微信扫码下载APP",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/e60af1b7f382fc29f4d24a2eb78f5352.png",
                    icon: "/www/gkzzd/uploads/20250321/f942bcd20c5c075157320dde1d2673ca.png",
                },
                {
                    id: 3,
                    title: "公众号",
                    content: "微信扫码关注公众号",
                    QR_code:
                        "/www/gkzzd/uploads/20250321/3fa8db5e1e457528dad09cddad08710c.jpg",
                    icon: "/www/gkzzd/uploads/20250321/8736597b3c11252732b75da807b23095.png",
                },
            ],
        };
    },
    methods: {
        homePageAd(val) {
            this.coupletLeft = val.couplet.left
            this.coupletRight = val.couplet.right
            this.T_A = val.T_A;
            this.AList = val.A;
            this.BList = val.B;
            this.text_link = val.text_link;
            this.schoolList = val.yx_bus_new;
            let list = this.newbusChild(
                this.newbus,
                this.schoolList,
                "province"
            );
            if (list.school.length > 0) {
                this.newbuslist = list.school;
            } else {
                this.newbuslist = [];
            }
        },
        closeProvince(val1, val2) {
            this.selectProvince = false;
            this.province = val1;
            this.province_id = val2;
            this.getTestPaperList();
            this.getList("招考公告", 9);
            this.getList("热门专题", 9);
            this.getList("头条新闻", 8);
            this.getList("院校介绍", 6);
            this.getList("历年分数", 6);
            this.getList("招生计划", 6);
            this.getList("招生章程", 6);
            setCookie("isTourist", 0, 1);
        },
        testPaperClick(ind) {
            this.testPaperActive = ind;
            this.paper_subject = this.testTitleList[ind].title;
            this.getTestPaperList();
        },
        async getNewsList() {
            const res = await this.$http.fetch("/api/HomePage/archivesList", {
                province_id: this.province_id,
                type: "高校新闻",
                channel_id: "",
                paper_subject: "",
                page: "",
                limit: 12,
                test_type: "",
                test_grade: "",
                test_year: this.date,
                title: "",
                get_total: 0,
            });
            if (res.status == 200) {
                this.newsList = res.data.list;
            }
        },
        async getGeneralList() {
            const res = await this.$http.fetch("/api/HomePage/archivesList", {
                province_id: this.province_id,
                type: "招生简章",
                channel_id: "",
                paper_subject: "",
                page: "",
                limit: 6,
                test_type: "",
                test_grade: "",
                test_year: this.date,
                title: "",
                get_total: 0,
            });
            if (res.status == 200) {
                this.generalList = res.data.list;
            }
        },
        async getTestPaperList() {
            const res = await this.$http.fetch("/api/HomePage/archivesList", {
                province_id: this.province_id,
                type: "查试卷",
                channel_id: "",
                paper_subject: this.paper_subject,
                page: "",
                limit: 20,
                test_type: "",
                test_grade: "",
                test_year: this.date,
                title: "",
                get_total: 0,
            });
            this.testPaperList = res.data.list;
        },
        async getList(type, limit) {
            const res = await this.$http.fetch("/api/HomePage/archivesList", {
                province_id: this.province_id,
                type: type,
                channel_id: "",
                paper_subject: "",
                page: "",
                limit: limit,
                test_type: "",
                test_grade: "",
                test_year: this.date,
                title: "",
                get_total: 0,
            });
            if (res.status == 200) {
                switch (type) {
                    case "招考公告":
                        this.list1 = res.data.list;
                        break;
                    case "热门专题":
                        this.list2 = res.data.list;
                        break;
                    case "头条新闻":
                    case "院校动态":
                        this.list3 = res.data.list;
                        this.top_list = res.data.top;
                        break;
                    case "院校介绍":
                        this.list4 = res.data.list;
                        break;
                    case "历年分数":
                        this.list5 = res.data.list;
                        break;
                    case "招生计划":
                        this.list6 = res.data.list;
                        break;
                    case "招生章程":
                        this.list7 = res.data.list;
                        break;
                }
            }
        },
        closeHeadersf(val1, val2) {
            this.province = val1;
            if (val2) {
                this.province_id = val2;
                this.getTestPaperList();
                this.getList("招考公告", 9);
                this.getList("热门专题", 9);
                this.getList("头条新闻", 8);
                this.getList("院校介绍", 6);
                this.getList("历年分数", 6);
                this.getList("招生计划", 6);
                this.getList("招生章程", 6);
            }
        },
        homeSearch() {
            this.$router.push("/fill/fill_search");
        },
        toPaper() {
            this.$router.push("/fill/fill_paper");
        },
        toPaperDetai(item) {
            this.$router.push(`/school/article?id=${item.id}`);
        },
        toNews(title) {
            this.$router.push(`/fill/fill_news?title=${title}`);
        },
        toSchool() {
            this.$router.push("/fill/fill_school");
        },
        toSchoolDetail(item) {
            this.$router.push(
                `/school/school_index?school_id=${item.school_id}`
            );
            this.getAdsClick(item.ads_id);
        },
        toConstitution() {
            this.$router.push("/fill/fill_constitution");
        },
        toGeneraDetail(item) {
            this.$router.push(`/school/article?id=${item.id}`);
        },
        async getAdsClick(adsID) {
            const res = await this.$http.fetch("/api/homepage/adsClick", {
                sf: this.province,
                ads_id: adsID,
            });
        },
        toCommon(item) {
            if (item.is_open) {
                if (item.is_vip) {
                    if (item.id === 7) {
                        window.location.href =
                            "https://h5.gkzzd.cn/wap/index/pre_inscription";
                    }
                    this.$router.push(item.path);
                } else {
                    if (store.state.user.token) {
                        this.dialogList = {
                            type: "C",
                            isTrue: true,
                            province: this.province,
                            save: true,
                            title: `您暂未开通【${item.business}】功能，开通系统即可体验`,
                            button: "开通",
                            width: "30%",
                            showClose: true,
                        };
                    } else {
                        this.is_login = true;
                        this.$message.error("请先登录");
                        setTimeout(() => {
                            this.is_login = false;
                        }, 100);
                    }
                }
            } else {
                this.dialogList = {
                    type: "C",
                    isTrue: true,
                    province: "",
                    save: true,
                    title: `当前省份未开放【${item.business}】功能，敬请期待！`,
                    button: "确定",
                    width: "30%",
                    showClose: true,
                };
            }
        },
        remove() {
            this.dialogList.isTrue = false;
        },
        getHomePage(val) {
            this.getValue(1, "is_open", val.wucha.is_open);
            this.getValue(1, "is_vip", val.wucha.is_vip);
            this.getValue(2, "is_open", val.wucha.is_open);
            this.getValue(2, "is_vip", val.wucha.is_vip);
            this.getValue(3, "is_open", val.xuanke.is_open);
            this.getValue(4, "is_open", val.moni.is_open);
            this.getValue(4, "is_vip", val.moni.is_vip);
            this.getValue(5, "is_open", val.wucha.is_open);
            this.getValue(5, "is_vip", val.wucha.is_vip);
        },
        getValue(id, keyName, value) {
            this.commonList.forEach((item) => {
                if (item.id === id) {
                    item[keyName] = value;
                }
            });
        },
        newbusMove(val) {
            this.newbus = val.province;
            let list = this.newbusChild(
                this.newbus,
                this.schoolList,
                "province"
            );
            if (list.school.length > 0) {
                this.newbuslist = list.school;
            } else {
                this.newbuslist = [];
            }
        },
        newbusChild(value, array, keyName) {
            const found = array.find((item) => item[keyName] === value);
            return found;
        },
        isMobile() {
            const userAgent =
                navigator.userAgent || navigator.vendor || window.opera;
            // 常见的移动设备标志
            return (
                /android/i.test(userAgent) ||
                /iPhone|iPad|iPod/i.test(userAgent)
            );
        },
        tab_click(val) {
            this.tab_index = val.id;
            this.getList(val.title, 8);
        },
        calculateLength(str) {
            let totalLength = 0;

            // 遍历字符串中的每个字符
            for (let i = 0; i < str.length; i++) {
                let char = str[i];

                // 判断是否为汉字（可以通过正则表达式匹配汉字）
                if (/[\u4e00-\u9fa5]/.test(char)) {
                    totalLength += 13; // 汉字贡献13
                } else if (/\d/.test(char)) {
                    totalLength += 5; // 数字贡献5
                } else {
                    totalLength += 10; // 其他字符10
                }
            }

            return totalLength;
        },
    },
    mounted() {
        this.province = getCookie("province");
        this.getTestPaperList();
        this.getList("招考公告", 9);
        this.getList("热门专题", 9);
        this.getList("头条新闻", 8);
        this.getList("院校介绍", 6);
        this.getList("历年分数", 6);
        this.getList("招生计划", 6);
        this.getList("招生章程", 6);
        this.commonListCopy = this.commonList.filter((item) => item.id === 4);
        if (this.isMobile()) {
            window.location.href = "https://www.gkzzd.cn/h5";
        }
    },
    created() {},
};
</script>
<style lang="scss">
@font-face {
    font-family: "FZKai-Z03S";
    src: url("../../font/方正楷体简体.TTF") format("truetype"); /* 确保路径正确 */
}
.newFill {
    position: relative;
    width: 100%;
    height: 100%;
    background: #f0f5ff;
    overflow-x: hidden;
    .main {
        width: 1200px;
        margin: 0 auto;
        position: relative;
        .mainBox {
            margin-top: 10px;
            .firstLeft {
                height: 100%;
                background: #fff;
                padding: 0 20px 0 30px;
                cursor: pointer;
                .mainSearch {
                    width: 100%;
                    height: 40px;
                    border: #3c78ff solid 1px;
                    color: #999999;
                    border-radius: 4px;
                }
                .mainButton {
                    width: 80px;
                    height: 40px;
                    background: #3c78ff;
                    color: #fff;
                    border-radius: 4px;
                }
            }
            .firstRight {
                height: 100%;
                font-size: 24px;
                color: #fff;
                background-color: #3c78ff;
                padding: 0 20px;
                cursor: pointer;
            }
            .thirdLeft {
                width: 590px;
                background: #fff;
                .list1 {
                    padding: 20px 20px 3px 29px;
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    .list1Item {
                        width: 261px;
                        border: 1px solid #e5e5e5;
                        margin-bottom: 19px;
                        padding: 24px 0;
                        cursor: pointer;
                    }
                }
            }
            .thirdRight {
                width: 590px;
                height: 100%;
                background: #fff;
                .list2 {
                    width: 100%;
                    padding: 15px 29px 15px 29px;
                    .list2Item {
                        margin-bottom: 16px;
                        box-sizing: border-box;
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
            .thirdTitle {
                border-bottom: 1px solid #e9e9e9;
                padding-left: 29px;
                padding-right: 29px;
                color: #3c78ff;
                .one {
                    border-left: 4px solid #3c78ff;
                    display: block;
                    text-indent: 9px;
                    color: #000;
                }
            }
            .circular {
                display: block;
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background: #3c78ff;
            }
            .borderR {
                border-right: 1px solid #ccc;
                &:last-child {
                    border: none;
                }
            }
            .schoolItem {
                width: 366px;
                height: 81px;
                border: 1px solid #ccc;
                border-radius: 5px;
            }
            .testPaperItem {
                width: 60px;
                height: 30px;
                border-radius: 4px;
                margin-right: 5px;
            }
            .testPaperItemActive {
                background: #3c78ff;
                color: #fff;
            }
            .testChildItem {
                border: 1px solid #ccc;
                box-sizing: border-box;
                padding: 20px 15px;
            }
            .newBus {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(33px, 1fr));
            }
            .newbus_title {
                padding: 5px 0;
                text-align: center;
                background: #f5f4f4;
                border-bottom: 1px solid #c9c6c6;
            }
            .newbus_active {
                border: 1px solid #c9c6c6;
                border-bottom: none;
                background: #fff;
                color: red;
            }
            .newbuslist {
                padding: 10px 20px;
                display: grid;
                grid-template-columns: repeat(5, 1fr); /* 4等分 */
                gap: 5px; /* 可选，设置每个格子之间的间距 */
                cursor: pointer;
                font-size: 12px;
            }
            .red {
                color: red;
            }
            .newbusA {
                &:hover {
                    text-decoration: underline;
                }
            }
            .tab_list {
                border: 1px solid #f5f5f5;
                color: #999;
                padding: 10px 20px;
            }
            .tab_active {
                border-top: 2px solid #3c78ff;
                border-left: 1px solid #f2f2f2;
                border-right: 1px solid #f2f2f2;
                color: #000;
                border-bottom: none;
                padding: 10px 20px;
            }
        }
        .leftImg {
            position: fixed;
            top: 25%;
            left: 30px;
        }
        .rightImg {
            position: fixed;
            top: 25%;
            right: 30px;
        }
        .popover_div {
            width: 100%;
        }
    }

    .hover {
        &:hover {
            text-decoration: underline;
        }
    }
}
.province_pop_up {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99;
}
.ellipsis {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    cursor: pointer;
    &:hover {
        text-decoration: underline;
        color: red;
    }
}
.suspension {
    position: fixed;
    bottom: 1%;
    right: 1px;
    transform: translate(-100%, -50%);
    background: #fff;
    border-radius: 25px;
}
</style>